module.exports = __webpack_public_path__ + "img/worm-preparing-01.4cfaf575.png";